var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"homeTitle"}},[_c('div',{staticClass:"t"},[_vm._v("T")]),_c('div',{staticClass:"content"},[_c('p',[_vm._v(_vm._s(this.content.Chinese))]),_c('p',[_vm._v(_vm._s(this.content.English))])]),_c('div',{staticClass:"line"})])}
var staticRenderFns = []

export { render, staticRenderFns }